<div class="inicio">

  <p class="titulo">CATÁLOGO DE ACTIVIDADES DE MANTENIMIENTO</p>

<!--TABLA CON LOS DATOS -->
    <div class="div"  >

        <!--Barra de búsqueda-->
        <div  class="grid-container2">
            <mat-form-field>
                <mat-label>BUSCAR</mat-label>
                <input matInput  (keyup)="applyFilter($event)"  placeholder="INGRESE DATO A BUSCAR">
            </mat-form-field>

        </div>

        <!--Boton Descargar reporte-->
        <div class="grid-container5">
            <button mat-raised-button style="background-color: #28e702;" (click)="this.banderaFormulario=true" > AGREGAR ACTIVIDAD DE MANTENIMIENTO
                <mat-icon> playlist_add </mat-icon>
            </button>&nbsp;
        </div>
        <!--FORMULARIO PARA AGREGAR UN TIPO-->
        <div class="divAddTipo" *ngIf="this.banderaFormulario==true" >
          <form #insertForm="ngForm" [formGroup]="formActividad" >

            <div class="grid-container2"  >
              <div class="celda"  >
                <mat-label class="label">Nombre de la actividad</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="Nombre de la actividad de mantenimiento"  formControlName="actividad" oninput="this.value = this.value.toUpperCase()"  required="Es necesario proporcionar el nombre de la actividad"/>
                </mat-form-field>
              </div>
              <div class="celda" >
                <mat-label class="label"> Tipo de mantenimiento  </mat-label>
                <mat-select placeholder="Seleccione el tipo de mantenimiento"  formControlName="tipoMant"   required >
                  <mat-option *ngFor="let tipo of listaTipoMant" [value]=tipo.id_tipo_mant>{{ tipo.nombre }} </mat-option>
                </mat-select>
              </div>
              <div class="celda" >
                <mat-label class="label"> Estatus  </mat-label>
                <mat-select placeholder="Elija el estatus"  formControlName="status"   required >
                  <mat-option *ngFor="let status of listaStatus" [value]=status>{{ status }} </mat-option>
                </mat-select>
              </div>

              <div class="celda" >
                <mat-label class="label"> Descripción </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="Descripción de la actividad de mantenimiento"  formControlName="descripcion" oninput="this.value = this.value.toUpperCase()" />
                </mat-form-field>
              </div>
            </div>
            <div class="wrapper">
              <button mat-raised-button style="background-color: #00e760;" *ngIf="this.banderaEditar" (click)="editarActividadMant()" >Editar <span class="material-icons">edit</span> </button>
              <button mat-raised-button style="background-color: #00e760;" *ngIf="this.banderaEditar==false" (click)="agregarActividadMant()" >Agregar <span class="material-icons">done</span> </button>
              <br><br>
              <button mat-raised-button style="background-color: #fd4545;" (click)="this.limpiarFormulario()" >Cancelar <mat-icon>cancel</mat-icon> </button>
            </div>
          </form>
        </div>

        <!--Tabla-->
        <table mat-table [dataSource] = "dataSource"  class="mat-elevation-z8">

            <ng-container matColumnDef="editar">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> EDITAR </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-mini-fab style="background-color: #0804e9;" (click)="mostrarActividadMant(element.id_actividad_mant)"> <span class="material-icons">edit</span> </button>
                </td>
            </ng-container>
            <ng-container matColumnDef="nombre_act">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ACTIVIDAD </th>
                <td mat-cell *matCellDef="let element"> {{element.nombre_act}} </td>
            </ng-container>
            <ng-container matColumnDef="tipo_mant">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO DE MANTENIMIENTO  </th>
              <td mat-cell *matCellDef="let element"> {{element?.tipo_mant?.nombre}} </td>
            </ng-container>
            <ng-container matColumnDef="status_actividad">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS  </th>
              <td mat-cell *matCellDef="let element"> {{element.status_actividad}} </td>
            </ng-container>
            <ng-container matColumnDef="descripcion">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> DESCRIPCIÓN </th>
              <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
            </ng-container>
            <ng-container matColumnDef="fecha_creacion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE CREACIÓN </th>
                <td mat-cell *matCellDef="let element"> {{element.fecha_creacion.substring(0,10)}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

        </table>
        <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>

  </div>



</div>
